import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeRoutingModule} from './home-routing.module';
import {HomeComponent} from './component/home.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {SectionFeaturesModule} from '../section-features/section-features.module';
import {SectionTestimonialsModule} from "../section-testimonials/section-testimonials.module";


@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    InfiniteScrollModule,
    SectionFeaturesModule,
    SectionTestimonialsModule
  ]
})
export class HomeModule {
}
